<div class="fs" [class.open]="open" [class.disabled]="disabled">
    <button type="button" class="fs-trigger" [disabled]="disabled" (click)="toggle()">
        <span [class.placeholder]="!value">{{ value || placeholder }}</span>
        <svg class="fs-chevron" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor"
             stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <polyline points="6 9 12 15 18 9"></polyline>
        </svg>
    </button>

    <div class="fs-panel" *ngIf="open">
        <div class="fs-search">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                 stroke-linecap="round" stroke-linejoin="round">
                <circle cx="11" cy="11" r="8"></circle>
                <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
            </svg>
            <input type="text" [(ngModel)]="search" placeholder="Search fields…" />
        </div>
        <ul class="fs-list">
            <li *ngFor="let o of filtered" [class.sel]="o === value" (click)="select(o)">{{ o }}</li>
            <li class="fs-empty" *ngIf="!filtered.length">No matches</li>
        </ul>
    </div>
</div>
